import Box from "@mui/material/Box";
import { Divider, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <HeaderText>{t("privacyPolicy")}</HeaderText>
      <CustomDivider />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("whatAreWeCollecting")}</b>
          <span>{t("whatAreWeCollectingDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("howDoWeProcessAndStoreYourData")}</b>
          <span>{t("howDoWeProcessAndStoreYourDataDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("useCookies")}</b>
          <span>{t("useCookiesDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("TransferOfDataToThirdParties")}</b>
          <span>{t("TransferOfDataToThirdPartiesDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("yourRights")}</b>
          <span>{t("yourRightsDescription")}</span>
        </div>
      </div>
    </Box>
  );
};

export default PrivacyPolicy;
